import { t } from "@/i18n-js/instance";
import { defaultData as primaryButtonDefaultData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/PrimaryButtonBlock/PrimaryButtonBlockDefaultData";
import { defaultData as secondaryButtonDefaultData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/SecondaryButtonBlock/SecondaryButtonBlockDefaultData";

export type ButtonType = "primaryButton" | "secondaryButton";

export const BUTTON_TYPE_OPTIONS: { value: ButtonType; label: string }[] = [
  {
    value: "primaryButton",
    label: t("builder_ui.prop_type.styles.button_types.primary"),
  },
  {
    value: "secondaryButton",
    label: t("builder_ui.prop_type.styles.button_types.secondary"),
  },
];

export const BUTTON_DEFAULT_DATA = {
  primaryButton: primaryButtonDefaultData,
  secondaryButton: secondaryButtonDefaultData,
};
